module.exports = __webpack_public_path__ + "static/img/rank_158.8774446.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_158.png
// module id = NgMB
// module chunks = 1